"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _TagCloseButton = require("../TagCloseButton/TagCloseButton");
var _Tag = require("./Tag.styles");
var _excluded = ["children", "defaultOpen", "icon", "isOpen", "onClose", "renderCloseButton", "size"];
/**
 * "md" tag gets "xs" icon
 * "sm" tag gets no icon
 */
var TAG_ICON_SIZES = {
  md: _constants.ICON_SIZES.xs
};

/**
 * @since 8.6.0
 */
var Tag = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var children = props.children,
    defaultOpen = props.defaultOpen,
    icon = props.icon,
    controlledOpen = props.isOpen,
    onClose = props.onClose,
    renderCloseButton = props.renderCloseButton,
    size = props.size,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(defaultOpen),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    uncontrolledOpen = _useState2[0],
    setUncontrolledOpen = _useState2[1];
  var isOpen = uncontrolledOpen;
  if (typeof controlledOpen !== 'undefined') {
    isOpen = controlledOpen;
  }
  var closeCallback = (0, _react.useCallback)(function () {
    setUncontrolledOpen(false);
    if (typeof onClose === 'function') {
      onClose(props);
    }
  }, [onClose, props, setUncontrolledOpen]);
  if (typeof isOpen === 'boolean' && !isOpen) {
    return null;
  }
  var iconSize = TAG_ICON_SIZES[size];
  var adjustedIcon;
  if (icon && iconSize) {
    adjustedIcon = /*#__PURE__*/(0, _react.cloneElement)(icon, {
      size: iconSize
    });
  }
  var closeButton;
  var appearance;
  if (isOpen && iconSize && typeof renderCloseButton === 'function') {
    closeButton = renderCloseButton({
      onClick: closeCallback
    });
    appearance = 'closeable';
  }
  var tag = /*#__PURE__*/_react.default.createElement(_Tag.StyledTag, (0, _extends2.default)({
    ref: forwardedRef,
    size: size,
    appearance: appearance || 'gray'
  }, rest), adjustedIcon, children, closeButton);
  return tag;
});
exports.Tag = Tag;
Tag.displayName = 'Tag';
Tag.propTypes = {
  /**
   * Tags are static by default, but you can set this to true to enable the ability to close a
   * tag. When enabled, the tag will close in an uncontrolled manner. You can use the `isOpen`
   * prop to control the open state in a controlled manner.
   *
   * @since 8.25.0
   */
  defaultOpen: _propTypes.default.bool,
  /**
   * A closeable tag where the close state is controlled.
   *
   * @since 8.25.0
   */
  isOpen: _propTypes.default.bool,
  /**
   * Function called when the tag is closed. The tag's props will be passed as the only argument.
   *
   * @since 8.25.0
   */
  onClose: _propTypes.default.func,
  /**
   * Change the tag size.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.TAG_SIZES)),
  /**
   * Change the tag text transform.
   *
   * @since 8.58.0
   */
  textTransform: _propTypes.default.oneOf(['capitalize', 'lowercase', 'uppercase', 'none']),
  /**
   * Add an `Icon` to the tag.
   *
   * Note: small tags do not support icons.
   */
  icon: _propTypes.default.node,
  /**
   * Change the tag colors. Defaults to `"gray"` for static tags, and `"closeable"` for closeable
   * tags.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.TAG_APPEARANCES)),
  /**
   * Text content of tag.
   */
  children: _propTypes.default.node,
  /**
   * A render function that returns a close button.
   *
   * @since 8.28.0
   */
  renderCloseButton: _propTypes.default.func
};
Tag.defaultProps = {
  size: _constants.TAG_SIZES.md,
  textTransform: 'uppercase',
  icon: undefined,
  children: undefined,
  renderCloseButton: function renderCloseButton(props) {
    return /*#__PURE__*/_react.default.createElement(_TagCloseButton.TagCloseButton, props);
  }
};